import { ThemeModel } from "../../../models/ThemeModel";
import { QuestionnaireModel } from "../../../models/QuestionnaireModel";
import { getCurrentBlock } from "./navigationUtilities";
import { NavigationState } from "../../../models/states/NavigationState";
import { ActionTypes } from "../../actions/types";
import {
    QUESTIONNAIRE_CHANGED,
    PREVIEW_THEME,
    NAVIGATION_PREVIOUS_PAGE,
    NAVIGATION_PAGE_READY,
    NAVIGATION_PREVIEW_QUESTION,
    NAVIGATION_NEXT_PAGE,
    CHANGE_LANGUAGE,
    SERVER_PAGE_CHANGED,
} from "../../actions";

export const themeSliceReducer = (
    state: ThemeModel,
    navigationState: NavigationState,
    action: ActionTypes,
    questionnaire: QuestionnaireModel,
): ThemeModel => {
    switch (action.type) {
        case QUESTIONNAIRE_CHANGED:
            if (state && state.isPreview) return state;
            return questionnaire.theme;
        case PREVIEW_THEME:
            return {
                ...action.theme,
                isPreview: true,
            };
        case CHANGE_LANGUAGE:
        case NAVIGATION_NEXT_PAGE:
        case NAVIGATION_PREVIEW_QUESTION:
        case NAVIGATION_PREVIOUS_PAGE:
        case SERVER_PAGE_CHANGED:
        case NAVIGATION_PAGE_READY: {
            const block = getCurrentBlock(navigationState);
            let newTheme = block && block.theme ? block.theme : questionnaire.theme;

            // If block theme exists but has empty settings, merge with questionnaire theme settings
            if (
                block &&
                block.theme &&
                (!block.theme.settings || Object.keys(block.theme.settings).length === 0)
            ) {
                newTheme = {
                    ...block.theme,
                    settings: questionnaire.theme?.settings || {},
                };
            }

            if (state && state.isPreview) return state;
            return newTheme;
        }
        default:
            return state;
    }
};
